import React from "react";
import numeral from "numeral";
import { Button, Col, Descriptions, Divider, Row, Tag } from "antd";
//
//component
//redux
//selector
import { bailiffJobDetailSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
//actions
//utils
//hook
import { FLOWS, useJobDetailFlow } from "hook/bailiff/job/flow/useJobDetail";
import { useResponsive } from "hook/useResponsive";
import { useSelector } from "react-redux";
import { orderBailiffAllSelector } from "store/bailiff/payment/order/order_bailiff.selector";
import { useJobDeposit } from "hook/bailiff/job/action/useJobDeposit";

//str
const JobDeposit = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useJobDetailFlow();
  const { loading, handleDeposit } = useJobDeposit();
  const { mobile } = useResponsive();
  const isFlow = flow === FLOWS.DEPOSIT;
  const columns = mobile ? 1 : 2;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffJobDetailSelector);
  const order = useSelector(orderBailiffAllSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderInfo = () => {
    const items = renderItems({ detail, order });
    return (
      <Descriptions
        size="small"
        bordered
        column={columns}
        layout="horizontal"
        items={items}
      />
    );
  };

  const renderNote = () => {
    if (order) return null;
    return (
      <div style={{ color: "red" }}>
        * Hệ thống đang ước tính tiền đặt cọc dựa trên tổng thời lượng file. Sau
        khi ước tính được giá tiền, bạn có thể tiến hành thanh toán đặt cọc.
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <Row gutter={[20, 30]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderInfo()}
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderNote()}
      </Col>
      <Divider style={{ margin: 0 }} />
      <Col xl={24} lg={24} md={24} xs={24}>
        <Button
          loading={loading}
          onClick={handleDeposit}
          size="middle"
          style={{ borderRadius: 5 }}
          type="primary"
          block
          disabled={order === null}
        >
          Tiến hành đặt cọc
        </Button>
      </Col>
    </Row>
  );
};
export default JobDeposit;

const renderItems = ({ detail, order }) => {
  const duration = detail?.duration || 0;
  const deposit = order?.depositAmount;
  const perpagePrice = order?.perpagePrice;
  //
  const labelSize = numeral(detail?.size / 1024 / 1024).format("0,0");
  const labelDuration = numeral(duration).format("0,0.00");
  const labelDeposit = numeral(deposit).format("0,0");
  const labelPerPagePrice = numeral(perpagePrice).format("0,0");

  const data = [
    {
      key: "1",
      label: "Tên File",
      children: <p>{detail?.name}</p>,
      span: 2,
    },
    {
      key: "2",
      label: "Loại",
      children: <p>{detail?.contentType}</p>,
    },
    {
      key: "3",
      label: "Kích thước",
      children: <p>{labelSize} MB</p>,
    },
    {
      key: "4",
      label: "Thời lượng",
      children: <p>{labelDuration} giây</p>,
    },
    {
      key: "5",
      label: "Tỉ giá chuyển đổi",
      children: <p>{labelPerPagePrice} vnđ / trang</p>,
    },
    {
      key: "6",
      label: "Số tiền đặt cọc",
      children: (
        <p style={{ color: !order ? "#d1d1d1" : "green", fontWeight: 500 }}>
          {labelDeposit} vnđ
        </p>
      ),
    },
    {
      key: "7",
      label: "Trạng Thái",
      children: <Tag color="orange">Đang chờ thanh toán</Tag>,
    },
  ];

  return data;
};
